import { createTheme } from '@mui/material/styles';

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: '#1ea0c0',
      light: '#43C3D3',
      dark: '#1C93B1'
    },
    secondary: {
      main: '#68AE45',
      light: '#43c3d3',
      dark: '#60A03F'
    },
    success: {
      main: '#52a000'
    },
    error: {
      main: '#E02020'
    },
    warning: {
      main: '#F39C12'
    },
    text: {
      primary: '#222',
      secondary: '#666',
      disabled: '#999'
    }
  },
  typography: {
    fontFamily: ['Montserrat', 'sans-serif'].join(','),
    fontWeightBold: 600,

    h1: {
      fontSize: 28,
      fontWeight: 600
    },
    h2: {
      fontSize: 24,
      fontWeight: 600
    },
    h3: {
      fontSize: 20,
      fontWeight: 500
    },
    h5: {
      fontSize: 18,
      fontWeight: 500
    },
    body2: {
      fontSize: 14,
      lineHeight: 'normal'
    },
    subtitle2: {
      fontSize: 16,
      fontWeight: 700,
      textTransform: 'uppercase'
    },
    caption: {
      fontSize: 18
    }
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          textDecorationColor: 'inherit',
          ...(ownerState.component === 'button' && {
            verticalAlign: 'baseline'
          })
        })
      }
    }
  }
});

export default theme;
